// extracted by mini-css-extract-plugin
export var textContainer = "styles-module__textContainer___u6_q7";